import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiCall } from 'utils/ApiCall';
import { Routes, HttpMethod, AppPages } from 'types/Enums';

const getTelegramStartPath = () => {
  const tg = window.Telegram;

  if (!tg?.WebApp) return null;

  const startParam = tg.WebApp.initDataUnsafe?.start_param;
  if (!startParam) return null;

  const parts = startParam.split('-');

  if (parts.length === 2) {
    const [action, username] = parts;
    return `/${action}/${username}`;
  }

  return `/${startParam}`;
};

const TelegramStartHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const targetPath = getTelegramStartPath();
    if (!targetPath) return;

    const handledParam = sessionStorage.getItem('tg_start_handled');

    if (handledParam === targetPath) return;
    if (location.pathname === targetPath) return;

    const resolveAndNavigate = async () => {
      let effectivePath = targetPath;

      if (targetPath.startsWith('/send/')) {
        const recipientSlug = targetPath.slice('/send/'.length);
        try {
          const me = await apiCall(Routes.GET_ME, HttpMethod.GET);
          if (me?.link_slug === recipientSlug) {
            effectivePath = AppPages.INBOX;
          }
        } catch (_) {
          // if /api/me fails, fall through to original path
        }
      }

      sessionStorage.setItem('tg_start_handled', targetPath);
      navigate(effectivePath, { replace: true });
    };

    resolveAndNavigate();
  }, [location.pathname, navigate]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem('tg_start_handled');
    };
  }, []);

  return null;
};

export default TelegramStartHandler;
